import Vue from 'vue';
import App from './App';
import router from './router';

import 'assets/scss/index.scss';
import './plugins/vant';
import './plugins/other';

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
